import TelemetryButton from "@/design-system/telemetry-button";
import { CbTopBaseResources } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources";
import { CbTopBaseResourcesEn } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources.En";
import { LoginModalView, useActiveLoginModalContext, useViewportInfoContext } from "@/src/contexts";
import { languageSelector } from "@/src/contexts/UserAuthenticationContext";
import PanelSection from "@/src/shared/panel-section";

import bgImg from "./../_assets/bg_hero_center.jpg";
import bgImgMobile from "./../_assets/bg_hero_right_mobile.jpg";

import * as css from "./../../CashbackTopSection.module.css";
import * as versionCss from "./lpVersionD.module.css";

export function LpTopComponentVersionD() {
    const ME_VERISON = "D";

    const resources = languageSelector(CbTopBaseResources, CbTopBaseResourcesEn);

    const { setActiveLoginModal } = useActiveLoginModalContext();
    const { isMobile } = useViewportInfoContext();

    const openRegistration = () => setActiveLoginModal(LoginModalView.Registration);

    return (
        <PanelSection
            telemetryCustom={{
                eventName: "cshbck-TopSection",
                actionType: "View",
                param1: ME_VERISON,
            }}
            className={versionCss.lpVersionD}
            initialInView
        >
            <div className={css.cashbackTopSectionComponent}>
                <div className={css.textContent}>
                    <h1 className={css.subject} dangerouslySetInnerHTML={{ __html: resources.title }} />
                    <span className={css.description}>{resources.subTitle}</span>

                    <TelemetryButton
                        as="button"
                        variant="magentaRound"
                        size={isMobile ? "M" : "XL"}
                        eventName="cshbck-topSectionRegister"
                        param1={ME_VERISON}
                        onClick={openRegistration}
                    >
                        {resources.registerText}
                    </TelemetryButton>
                </div>
            </div>
            <img src={isMobile ? bgImgMobile : bgImg} className={versionCss.bgHero} />
        </PanelSection>
    );
}
